(function statusModuleDefinition() {
    'use strict';

    angular.module('Status', ['ui.router', 'Config', 'Entities', 'ErrorsExtend'])
        .config(['configProvider', '$stateProvider', 'loginProvider',
            function statusConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('status-info', {
                    url: "/Status/Info",
                    templateUrl: config.resourceUrl('/views/status/status-info.html'),
                    controller: 'StatusInfoController',
                    authorize: true,
                    roles: loginProvider.roleCondition('APPLICATION INFORMATION')
                });
            }
        ]);
})();